import React, { useState } from 'react';
import {
  FaUsers,
  FaUserCheck,
  FaRegUser,
} from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';

const MyTeam = () => {
    const { isDarkMode } = useTheme();

  const [activeTab, setActiveTab] = useState('Direct');

  // COLORS
  const G = '#d4af37';
  const G2 = '#f0c842';

  const bg = isDarkMode ? '#0d0d0d' : '#f5f5f5';
  const card = isDarkMode ? '#171717' : '#ffffff';
  const card2 = isDarkMode ? '#1f1f1f' : '#fafafa';

  const border = isDarkMode
    ? 'rgba(255,255,255,.06)'
    : 'rgba(0,0,0,.06)';

  const text = isDarkMode ? '#ffffff' : '#111111';
  const muted = isDarkMode ? '#9ca3af' : '#6b7280';

  // DATA
  const teamData = {
    Direct: [
      {
        id: 1,
        name: 'Rahul Sharma',
        mobile: '9876543210',
        status: 'Active',
        join: '2 Days Ago',
      },
      {
        id: 2,
        name: 'Aman Gupta',
        mobile: '9876500000',
        status: 'Pending',
        join: '5 Days Ago',
      },
    ],

    Team: [
      {
        id: 3,
        name: 'Vikas Kumar',
        mobile: '9876511111',
        status: 'Active',
        join: '1 Week Ago',
      },
      {
        id: 4,
        name: 'Neha Singh',
        mobile: '9876522222',
        status: 'Active',
        join: '3 Days Ago',
      },
    ],

    Active: [
      {
        id: 5,
        name: 'Rohit Verma',
        mobile: '9876533333',
        status: 'Verified',
        join: 'Today',
      },
    ],
  };

  // STATS
  const stats = [
    {
      title: 'Direct',
      count: 2,
      icon: <FaRegUser />,
      color: G,
    },
    {
      title: 'Active',
      count: 1,
      icon: <FaUserCheck />,
      color: '#10b981',
    },
    {
      title: 'Team',
      count: 4,
      icon: <FaUsers />,
      color: '#3b82f6',
    },
  ];

  return (
    <div
      style={{
        width: '100%',
  
      }}
    >

      {/* SMALL STATS */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr))',
          gap: 12,
          marginBottom: 18,
        }}
      >
        {stats.map((item, index) => (
          <div
            key={index}
            style={{
              background: card,
              border: `1px solid ${border}`,
              borderRadius: 18,
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >

            {/* ICON */}
            <div
              style={{
                width: 38,
                height: 38,
                borderRadius: 12,
                background: `${item.color}15`,
                color: item.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 15,
                flexShrink: 0,
              }}
            >
              {item.icon}
            </div>

            {/* TEXT */}
            <div>
              <div
                style={{
                  fontSize: 11,
                  color: muted,
                  fontWeight: 600,
                  marginBottom: 3,
                }}
              >
                {item.title}
              </div>

              <div
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                  color: text,
                  lineHeight: 1,
                }}
              >
                {item.count}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MAIN TABLE CARD */}
      <div
        style={{
          background: card,
          borderRadius: 22,
          border: `1px solid ${border}`,
          overflow: 'hidden',
        }}
      >

        {/* HEADER */}
        <div
          style={{
            padding: '18px 20px',
            borderBottom: `1px solid ${border}`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 14,
          }}
        >

          {/* TITLE */}
          <div>
            <div
              style={{
                color: G,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: 'uppercase',
                marginBottom: 4,
              }}
            >
              Referral Network
            </div>

            <div
              style={{
                color: text,
                fontSize: 22,
                fontWeight: 800,
              }}
            >
              My Team
            </div>
          </div>

          {/* TABS */}
          <div
            style={{
              display: 'flex',
              gap: 8,
              background: isDarkMode ? '#111' : '#f5f5f5',
              padding: 5,
              borderRadius: 14,
            }}
          >
            {['Direct', 'Team', 'Active'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: '9px 16px',
                  borderRadius: 10,
                  border: 'none',
                  background:
                    activeTab === tab
                      ? `linear-gradient(135deg, ${G}, ${G2})`
                      : 'transparent',

                  color:
                    activeTab === tab
                      ? '#000'
                      : muted,

                  fontWeight: 700,
                  fontSize: 12,
                  cursor: 'pointer',
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* TABLE */}
        <div
          style={{
            overflowX: 'auto',
          }}
        >
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
            }}
          >

            {/* HEAD */}
            <thead
              style={{
                background: isDarkMode ? '#1d1d1d' : '#faf8f3',
              }}
            >
              <tr>
                {['Name', 'Mobile', 'Status', 'Joined'].map((head                               ) => (
                  <th
                    key={head}
                    style={{
                      padding: '16px 18px',
                      textAlign: 'left',
                      color: muted,
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: 1,
                      textTransform: 'uppercase',
                      borderBottom: `1px solid ${border}`,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {teamData[activeTab].map((member, index) => (
                <tr
                  key={member.id}
                  style={{
                    background:
                      index % 2 === 0
                        ? 'transparent'
                        : isDarkMode
                        ? '#141414'
                        : '#fcfcfc',
                  }}
                >

                  {/* NAME */}
                  <td
                    style={{
                      padding: '16px 18px',
                      borderBottom: `1px solid ${border}`,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                      }}
                    >

                      {/* AVATAR */}
                      <div
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: '50%',
                          background: `linear-gradient(135deg, ${G}, ${G2})`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#000',
                          fontWeight: 800,
                          fontSize: 14,
                          flexShrink: 0,
                        }}
                      >
                        {member.name.charAt(0)}
                      </div>

                      {/* NAME */}
                      <div
                        style={{
                          color: text,
                          fontWeight: 700,
                          fontSize: 14,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {member.name}
                      </div>
                    </div>
                  </td>

                  {/* MOBILE */}
                  <td
                    style={{
                      padding: '16px 18px',
                      borderBottom: `1px solid ${border}`,
                      color: muted,
                      fontSize: 13,
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {member.mobile}
                  </td>

                  {/* STATUS */}
                  <td
                    style={{
                      padding: '16px 18px',
                      borderBottom: `1px solid ${border}`,
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '6px 12px',
                        borderRadius: 30,

                        background:
                          member.status === 'Verified'
                            ? 'rgba(16,185,129,.12)'
                            : member.status === 'Active'
                            ? 'rgba(59,130,246,.12)'
                            : 'rgba(245,158,11,.12)',

                        color:
                          member.status === 'Verified'
                            ? '#10b981'
                            : member.status === 'Active'
                            ? '#3b82f6'
                            : '#f59e0b',

                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {member.status}
                    </div>
                  </td>

                  {/* JOIN */}
                  <td
                    style={{
                      padding: '16px 18px',
                      borderBottom: `1px solid ${border}`,
                      color: muted,
                      fontSize: 13,
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {member.join}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyTeam;